/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export interface ComputingPlatform {
	platformType: PlatformType;
	area: string;
	region: string;
	cloudProvider: CloudProvider;
}

export type CloudProvider = "Amazon Web Services" | "Google Cloud Platform" | "Microsoft Azure";

export enum PlatformType {
	CLOUD_COMPUTING = "CLOUD_COMPUTING",
	ON_PREMISE = "ON_PREMISE"
}
